export default __webpack_public_path__ + "static/media/googleround.da4963b8.svg";